import { createSelector } from "reselect"
import { pick, chain } from "lodash"
import { computeData } from "modules/analyze-historical-exposure/selectors/data"
import { getAllCategoryItems } from "modules/analyze-historical-exposure/selectors/items"
import { getExposure } from "modules/analyze-historical-exposure/selectors/exposure"
import { computeSelected, computeSelectedValue, getLastContributor } from "helpers/contributors"

const getSelectedDate = (_, props) => props.selectedDate
const getSelectedRaw = state => state.modules.analyzeExposureDetails.selected

const getContributorData = createSelector(
  [getAllCategoryItems, getExposure],
  (items, exposure) => computeData(items, exposure),
)

export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems],
  computeSelected,
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems],
  (data, date, items) => {
    const lastContributor = getLastContributor(data, date) || {}

    return chain(items)
      .map(item => ({
        ...pick(item, ["label", "id", "color", "category", "favorite", "field", "isAggregated"]),
        value: lastContributor[item.id],
      }))
      .filter(item => item.value || item.favorite)
      .value()
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  computeSelectedValue,
)
